let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g5cuy")).then(() => parcelRequire('aVOnz'));